module.exports = __webpack_public_path__ + "img/beXPtbMM.68b0968e.svg";